import React, { useState, useEffect } from "react";
import { client } from "../../../../client";
import { Link } from "react-router-dom";
import "./Blogs.scss";

const BlogCard = ({ blog }) => {
  return (
    <div className="blog-card">
      <div className="card-top">
        <div className="image-container">
          <img src={blog.mainImage?.asset?.url} alt={blog.title} />
        </div>
        <Link to={`/blog/${blog.slug?.current}`} className="read-article">
          <span>Read Article</span>
          <div className="arrow-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </Link>
      </div>
      <div className="card-bottom">
        <h4 className="blog-title">{blog.title}</h4>
      </div>
    </div>
  );
};

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "post"] | order(_updatedAt desc) [0...3] {
                title, 
                slug,
                mainImage {
                    asset -> {
                        url
                    }
                }
            }`,
      )
      .then((data) => {
        setBlogs(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section className="blogs-section">
        <div className="blogs-container">
          <p>Loading blogs...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="blogs-section">
      <div className="blogs-container">
        {blogs.map((blog) => (
          <BlogCard key={blog.slug?.current || Math.random()} blog={blog} />
        ))}
      </div>
    </section>
  );
};

export default Blogs;
